import theme from '@ifca-root/react-component/src/assets/theme'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ExcelInput } from '@ifca-root/react-component/src/components/Input/ExcelUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import { List, ListItem, ListItemText, useMediaQuery } from '@material-ui/core'
import BlackDollarIcon from 'assets/icons/Money/black-dollar.svg'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useCreateExternalJournalMutation,
  useGetCheckingValidationExtJournalQuery,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

export const ExternalJournalExcelValidation = (props: any) => {
  let location = useLocation()
  const passedData: any = location?.state
  const fileName = passedData.fileTitle
  let history = useHistory()
  const { CompanyID }: any = useParams()
  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
  })
  const [openDialog, setOpenDialog] = useState(false)
  const [errorNumberingStructure, setErrorNumberingStructure] = useState(false)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    loading: checkingValidationExtJournalLoading,
    error: getCheckingValidationExtJournalError,
    data: { getCheckingValidationExtJournal } = {
      getCheckingValidationExtJournal: [],
    },
  } = useGetCheckingValidationExtJournalQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      ExternalJournalImportInput: passedData.excelData,
      CompanyID: CompanyID,
    },
    onCompleted: ({ getCheckingValidationExtJournal }) => {
      const flatData = Object.values(getCheckingValidationExtJournal).flat()
      let ErrorData: any = []
      let ValidData: any = []

      flatData?.map(x => {
        if (x['ErrorList']?.length > 0)
          ErrorData.push({
            DepartmentCode: x['DepartmentCode'],
            DocAmt: x['DocAmt'],
            JournalDescription: x['JournalDescription'],
            AccountName: x['AccountName'],
            JournalType: x['JournalType'],
            JournalDate: x['JournalDate'],
            MasterCOACode: x['MasterCOACode'],
            RefNo: x['RefNo'],
            Remark: x['Remark'],
            TaxCode: x['TaxCode'],
            TaxRate: x['TaxRate'],
            PrincipalAmt: x['PrincipalAmt'],
            RowNo: x['RowNo'],
            ErrorList: x['ErrorList'],
          })
        else
          ValidData.push({
            DepartmentCode: x['DepartmentCode'],
            DocAmt: x['DocAmt'],
            JournalDescription: x['JournalDescription'],
            AccountName: x['AccountName'],
            JournalType: x['JournalType'],
            JournalDate: x['JournalDate'],
            MasterCOACode: x['MasterCOACode'],
            RefNo: x['RefNo'],
            Remark: x['Remark'],
            TaxCode: x['TaxCode'],
            TaxRate: x['TaxRate'],
            PrincipalAmt: x['PrincipalAmt'],
            RowNo: x['RowNo'],
            ErrorList: x['ErrorList'],
          })
      })

      setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
    },
  })

  const [
    createExternalJournal,
    { loading: creatExternalJournalLoading, error: createExternalJournalError },
  ] = useCreateExternalJournalMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      history.push({
        pathname: `/general-ledger/${CompanyID}/external-journal`,
        state: {
          success: true,
          msgMode: 'create',
        },
      })
    },
  })

  const {
    loading: docNumHeaderLoading,
    error: docNumHeaderError,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RefTable: 'GL_ExternalJournal',
    },
  })

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    snackBarMessage,
    currentData,
    setCurrentData,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2()

  const createExtJournalExcel = data => {
    let stringifyData = JSON.stringify(data)

    createExternalJournal({
      variables: {
        ExtJournalInput: { Obj: stringifyData },
        CompanyID: CompanyID,
        DocRefName: fileName,
      },
    })
  }

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  return (
    <>
      {docNumHeaderLoading && <Loading />}
      {creatExternalJournalLoading && <Loading />}
      {checkingValidationExtJournalLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() =>
          history.push(`/general-ledger/${CompanyID}/external-journal`)
        }
        smTitle={'General Ledger'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Journal Management' },
          { name: 'External Journal', current: true },
        ]}
      />

      <DynamicSubHeader
        style={{
          marginTop: '-2px',
        }}
        title={'External Journal Excel Upload'}
        rightText={<span className="c-orange">Validation</span>}
      />
      <List className="search-header fixed-search-header with-dynamic">
        <ListItem>
          <ListItemText
            primary={
              <>
                <span className="xsTitle flex-space">{fileName}</span>
              </>
            }
          />
        </ListItem>
      </List>

      <ContentWrapper
        style={{ marginTop: isDesktop ? '140px' : '75px' }}
        float
        footer
      >
        {/* Problem List */}
        {validatedData.ErrorData?.length > 0 && (
          <>
            <List style={{ marginBottom: '-13px' }}>
              <ListItem>
                <ListItemText
                  primary={
                    <>
                      <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                        Problem{' '}
                        {
                          <>
                            (
                            <span className="highlight-text">
                              {validatedData.ErrorData?.length}
                            </span>
                            )
                          </>
                        }
                      </span>
                    </>
                  }
                />
              </ListItem>
            </List>
            <List className="core-list">
              {validatedData.ErrorData?.map((el, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={
                      <>
                        <div className="xsTitle text-noflow">
                          <div className="mdDesc date-width ">
                            {formatDate(el.JournalDate)}{' '}
                          </div>
                          <div className="desc">
                            {' '}
                            {el.RefNo} |{' '}
                            <span>
                              <img
                                src={BlackDollarIcon}
                                style={{
                                  width: '12px',
                                  marginBottom: '-2px',
                                  font: 'xxTitle highlight-text',
                                  paddingRight: '5px',
                                }}
                              />

                              {el.DocAmt === null ? null : amtStr(el.DocAmt)}
                            </span>
                          </div>
                          <div className="desc">
                            {el.MasterCOACode} | {el.DepartmentCode}
                          </div>
                          <div className="desc"> {el.JournalDescription}</div>
                          <div className="desc"> {el.Remark}</div>
                          <div className="desc"> {el.AccountName}</div>
                          {el?.TaxCode || el?.TaxRate || el?.PrincipalAmt ? (
                            <div className="desc">
                              {' '}
                              {el?.TaxCode} |{' '}
                              {el?.TaxRate ? `${el?.TaxRate}%` : null} |{' '}
                              {el?.PrincipalAmt ? (
                                <span>
                                  <img
                                    src={BlackDollarIcon}
                                    style={{
                                      width: '12px',
                                      marginBottom: '-2px',
                                      font: 'xxTitle highlight-text',
                                      paddingRight: '5px',
                                    }}
                                  />

                                  {el?.DocAmt === null
                                    ? null
                                    : amtStr(el?.PrincipalAmt)}
                                </span>
                              ) : null}{' '}
                            </div>
                          ) : null}
                          <div
                            className="fw-medium text-noflow"
                            style={{ color: 'red' }}
                          >
                            {' '}
                            Row No: {el.RowNo}
                          </div>
                          <div
                            className="fw-medium text-noflow"
                            style={{ color: 'red' }}
                          >
                            {' '}
                            {el.ErrorList?.map((x, index) => {
                              if (index == el.ErrorList?.length - 1)
                                return `${x}`
                              else return `${x}, `
                            })}
                          </div>
                        </div>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </>
        )}

        {/* Validation List */}
        {validatedData.ValidData?.length > 0 && (
          <>
            <List style={{ marginBottom: '-13px' }}>
              <ListItem>
                <ListItemText
                  primary={
                    <>
                      <span className="xsTitle" style={{ marginLeft: '-9px' }}>
                        Validated{' '}
                        {
                          <>
                            (
                            <span className="highlight-text">
                              {validatedData.ValidData?.length}
                            </span>
                            )
                          </>
                        }
                      </span>
                    </>
                  }
                />
              </ListItem>
            </List>
            <List className="core-list">
              {validatedData.ValidData?.map((el, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={
                      <>
                        <div className="xsTitle text-noflow">
                          <div className="mdDesc date-width ">
                            {formatDate(el.JournalDate)}{' '}
                          </div>
                          <div className="desc">
                            {' '}
                            {el.RefNo} |{' '}
                            <span>
                              <img
                                src={BlackDollarIcon}
                                style={{
                                  width: '12px',
                                  marginBottom: '-2px',
                                  font: 'xxTitle highlight-text',
                                  paddingRight: '5px',
                                }}
                              />

                              {amtStr(el.DocAmt)}
                            </span>
                          </div>
                          <div className="desc">
                            {el.MasterCOACode} | {el.DepartmentCode}
                          </div>
                          <div className="desc"> {el.JournalDescription}</div>
                          <div className="desc"> {el.Remark}</div>
                          <div className="desc"> {el.AccountName}</div>
                          {el?.TaxCode || el?.TaxRate || el?.PrincipalAmt ? (
                            <div className="desc">
                              {' '}
                              {el?.TaxCode} |{' '}
                              {el?.TaxRate ? `${el?.TaxRate}%` : null} |{' '}
                              {el?.PrincipalAmt ? (
                                <span>
                                  <img
                                    src={BlackDollarIcon}
                                    style={{
                                      width: '12px',
                                      marginBottom: '-2px',
                                      font: 'xxTitle highlight-text',
                                      paddingRight: '5px',
                                    }}
                                  />

                                  {el?.DocAmt === null
                                    ? null
                                    : amtStr(el?.PrincipalAmt)}
                                </span>
                              ) : null}{' '}
                            </div>
                          ) : null}
                        </div>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </ContentWrapper>

      <ExcelInput
        showFooter={false}
        showDupErrors={true}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openFileUpload}
        setOpenUpload={setOpenFileUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        onUploadTemplate={() => {
          history.push({
            pathname: `/general-ledger/${CompanyID}/external-journal/validation`,
            state: {
              excelData: currentData?.map(x => {
                return {
                  JournalDate:
                    x?.JournalDate === null ? null : new Date(x?.JournalDate),
                  JournalType:
                    x?.JournalType === null ? null : `${x?.JournalType}`,
                  RefNo: `${x?.RefNo}`,
                  JournalDescription:
                    x?.JournalDescription === null
                      ? null
                      : `${x?.JournalDescription}`,
                  AccountName:
                    x?.AccountName === null ? null : `${x?.AccountName}`,
                  MasterCOACode:
                    x?.MasterCOACode === null ? null : `${x?.MasterCOACode}`,
                  DepartmentCode:
                    x?.DepartmentCode === null ? null : `${x?.DepartmentCode}`,
                  Remark: x?.Remark === null ? null : `${x?.Remark}`,
                  DocAmt: x?.DocAmt === null ? null : Number(x?.DocAmt),
                  TaxCode: x?.TaxCode === null ? null : `${x?.TaxCode}`,
                  TaxRate: x?.TaxRate === null ? null : Number(x?.TaxRate),
                  PrincipalAmt:
                    x?.PrincipalAmt === null ? null : Number(x?.PrincipalAmt),
                  RowNo: x?.rowNo,
                }
              }),
              fileTitle: fileTitle,
            },
          })
          setOpenFileUpload(false)
          resetFileUpload()
          setFileTitle('')
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={() => {}}
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: snackBarMessage,
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />
      <Footer
        options={
          validatedData.ErrorData?.length === 0 &&
          validatedData.ValidData?.length > 0
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true)
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenFileUpload(true)
                  },
                },
              ]
        }
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
        }}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <span
                    className="title c-orange flex-space"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                  >
                    Upload Confirmation
                  </span>
                </div>
              </div>
            ),
          },
          body: () => (
            <div>
              <span>{'Are you sure to upload?'}</span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    if (getDocumentNumberHeader?.length > 0) {
                      createExtJournalExcel(getCheckingValidationExtJournal)
                      setOpenDialog(false)
                    } else {
                      setOpenDialog(false)
                      setErrorNumberingStructure(true)
                    }
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <CommonDialog
        fullWidth={true}
        open={errorNumberingStructure}
        onClose={() => {
          setErrorNumberingStructure(false)
        }}
        sections={{
          header: {
            dynamic: (
              <>
                <span className="xsTitle flex-space" style={{ color: 'red' }}>
                  Error!
                </span>
              </>
            ),
          },
          body: () => (
            <div>
              <span>
                {'Document Numbering for External Journal is not created.'}
              </span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => {
                    setErrorNumberingStructure(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
